/**
 * 인앱 브라우저 감지 유틸리티
 * Instagram, KakaoTalk, Naver, LINE, Facebook 등의 인앱 브라우저를 감지합니다.
 * 이 브라우저들에서는 Google OAuth 팝업이 차단됩니다.
 */

const IN_APP_BROWSER_PATTERNS = [
  'FBAN', 'FBAV',           // Facebook
  'Instagram',              // Instagram
  'KAKAOTALK',              // KakaoTalk
  'NAVER',                  // Naver
  'Line/',                  // LINE
  'DaumApps',               // Daum/Kakao
  'SamsungBrowser/.*CrossApp', // Samsung Internet in-app
  'Twitter',                // Twitter/X
  'MicroMessenger',         // WeChat
  'Snapchat',               // Snapchat
  'Threads',                // Threads
] as const;

export function isInAppBrowser(): boolean {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  return IN_APP_BROWSER_PATTERNS.some(pattern => new RegExp(pattern, 'i').test(ua));
}

/**
 * URL을 클립보드에 복사하는 함수
 * 인앱 브라우저에서는 시스템 브라우저를 프로그래밍으로 열 수 없으므로,
 * 링크를 복사하고 사용자에게 직접 열도록 안내합니다.
 */
/**
 * 인앱 브라우저에서 외부 브라우저로 URL을 여는 함수
 * Android: intent:// 스킴으로 Chrome 실행 시도
 * iOS/기타: 클립보드 복사 후 사용자에게 안내
 */
export function openInExternalBrowser(url: string): boolean {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);

  if (isAndroid) {
    // Android intent:// 스킴으로 Chrome 실행 시도
    const intentUrl = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
    window.location.href = intentUrl;
    return true;
  }

  // iOS 및 기타: 프로그래밍으로 외부 브라우저를 열 수 없음
  return false;
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // clipboard API 미지원 시 fallback
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
  }
}
